export default __webpack_public_path__ + "static/media/limit_95.088fa213.svg";